export default __webpack_public_path__ + "static/media/logo.77c891fc.png";